export default __webpack_public_path__ + "static/media/toys.0c25903b.png";